import { FeatureFlag } from '@/types/featureFlag';

// Fetched once at boot by routes, so reads of these below resolve from the cache. A key set goes
// to the network if any one member is missing, so a flag asked for alongside these belongs here.
export const PATIENT_DETAILS_FLAGS = {
    calendarRail: FeatureFlag.DASHBOARD_PATIENT_DETAILS_CALENDAR_RAIL,
    layoutV2: FeatureFlag.DASHBOARD_PATIENT_DETAILS_LAYOUT_V2,
    schedulingTasks: FeatureFlag.DASHBOARD_PATIENT_DETAILS_SCHEDULING_TASKS,
    tableV2: FeatureFlag.DASHBOARD_PATIENT_DETAILS_VISITS_TABLE_V2,
    hasOrders: FeatureFlag.ORDERS,
    hasVisitRowSync: FeatureFlag.DASHBOARD_PATIENT_DETAILS_VISIT_ROW_SYNC,
    editVisitServices: FeatureFlag.DASHBOARD_EDIT_VISIT_SERVICES_DIALOG,
    editVisitFulfillmentWindow: FeatureFlag.DASHBOARD_EDIT_VISIT_FULFILLMENT_WINDOW_DIALOG,
    episodesSupported: FeatureFlag.EPISODES_OF_CARE,
    allEpisodesView: FeatureFlag.DASHBOARD_ALL_EPISODES_VIEW,
    toggleCanceledVisits: FeatureFlag.DASHBOARD_TOGGLE_CANCELED_VISITS,
};
